import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const TopicChat = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#FDFDFD"/>
      <path d="M28.5 22.5C28.5 23.0304 28.2893 23.5391 27.9142 23.9142C27.5391 24.2893 27.0304 24.5 26.5 24.5H14.5L10.5 28.5V12.5C10.5 11.9696 10.7107 11.4609 11.0858 11.0858C11.4609 10.7107 11.9696 10.5 12.5 10.5H26.5C27.0304 10.5 27.5391 10.7107 27.9142 11.0858C28.2893 11.4609 28.5 11.9696 28.5 12.5V22.5Z" stroke="#2E434D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </SvgIcon>
  );
}

export default TopicChat;